export const filterLowerProofOfIdentity = (flags, items, predicate) =>
  items.filter((item) => flags[item.id] === true && predicate(item.authnContextClass));
